export var LoadedEvent = 'loaded';

/** 中台支付相关事件名集合 */
export var PaymentSDKWillReadyEvent = 'PaymentSDKWillReady';
export var PaymentSDKWillPayEvent = 'PaymentSDKWillPay';
export var PaymentSDKPayEvent = 'PaymentSDKPay';
export var PaymentSDKPayFailEvent = 'PaymentSDKPayFail';
export var PaymentSDKRedirectEvent = 'PaymentSDKRedirect';

/** 交易支付相关事件名集合 */
// 下单事件
export var SLPaymentSDKOrderEvent = 'SLPaymentSDKOrderEvent';
// 初始化事件
export var SLPaymentSDKInitEvent = 'SLPaymentSDKInitEvent';
// 支付失败事件
export var SLPaymentSDKPayErrorEvent = 'SLPaymentSDKPayErrorEvent';
// 支付事件
export var SLPaymentSDKPayEvent = 'SLPaymentSDKPayEvent';
// 支付成功事件
export var SLPaymentSDKPaySuccessEvent = 'SLPaymentSDKPaySuccessEvent';
// 支付窗口关闭时间
export var SLPaymentSDKCloseEvent = 'SLPaymentSDKCloseEvent';